import { OverrideSettings } from 'src/types/override-settings';
import { createReducer } from 'src/utils/create-reducer';

import {
  LoadRepositoryPage,
  TOGGLE_CLONE_DIALOG,
  TOGGLE_SYNC_DIALOG,
  UNLOAD_REPOSITORY,
  UPDATE_REPOSITORY_SECTION_OVERRIDE_SETTINGS,
} from '../actions';
import { Mirror } from '../types';

export type RepositorySizeLimits = {
  hard: number;
  soft: number;
  readOnly: number;
};

export type RepositorySectionState = {
  currentRepository: string | null | undefined;
  isCloneDialogOpen: boolean;
  isSyncDialogOpen: boolean;
  mirrors: Mirror[] | null;
  sizeLimits: RepositorySizeLimits;
  overrideSettings: OverrideSettings;
};

const initialState: RepositorySectionState = {
  currentRepository: null,
  isCloneDialogOpen: false,
  isSyncDialogOpen: false,
  mirrors: null,
  sizeLimits: {
    soft: Infinity,
    hard: Infinity,
    readOnly: Infinity,
  },
  overrideSettings: {},
};

// eslint-disable-next-line import/no-default-export
export default createReducer(initialState, {
  [LoadRepositoryPage.SUCCESS](state, action) {
    const { sizeLimits, overrideSettings, override_settings, ...result } =
      action.payload.result;
    return {
      ...state,
      ...result,
      sizeLimits: {
        soft: sizeLimits?.soft || Infinity,
        hard: sizeLimits?.hard || Infinity,
        readOnly: sizeLimits?.readOnly || Infinity,
      },
      // This should work if backend changes snake-casing to
      // camel-casing to follow current convention
      overrideSettings: overrideSettings || override_settings,
    };
  },

  [UNLOAD_REPOSITORY](state) {
    return { ...state, currentRepository: null, mirrors: null };
  },

  [UPDATE_REPOSITORY_SECTION_OVERRIDE_SETTINGS](state, action) {
    return {
      ...state,
      overrideSettings: { ...state.overrideSettings, ...action.payload },
    };
  },

  [TOGGLE_CLONE_DIALOG](state, action) {
    return {
      ...state,
      isCloneDialogOpen: action.payload,
    };
  },

  [TOGGLE_SYNC_DIALOG](state, action) {
    if (action.payload === state.isSyncDialogOpen) {
      return state;
    }

    return {
      ...state,
      isSyncDialogOpen: action.payload,
    };
  },
});
